import { MapPin, Search } from "lucide-react";
import Container from "@/components/ui/Container";

const FEATURED = {
  title: "7 Days Plan in Italy",
  location: "Italy",
  image: "/images/7_day_plan_italy.png",
};

const OTHERS = [
  {
    title: "4 Days Plan for Las Vegas, USA",
    location: "Las Vegas, USA",
    image: "/images/5_day_plan.png",
  },
  {
    title: "3 Days Plan for London, UK",
    location: "London, UK",
    image: "https://images.unsplash.com/photo-1513635269975-59663e0ac1ad?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
  {
    title: "3 Days Plan for Cuba",
    location: "Cuba",
    image: "https://images.unsplash.com/photo-1500315331616-db4f707c24d1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
  },
];

export function ExploreItaly() {
  return (
    <section className="py-12 bg-[#FDF9F5]">
      <Container>
        <div className="flex flex-col md:flex-row justify-between md:items-center mb-6 gap-4">
          <h2 className="text-[#0F766E] text-2xl font-bold">Explore Italy</h2>

          <div className="relative">
            <div className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400">
              <Search size={16} />
            </div>
            <input type="text" placeholder="Search destinations..." className="pl-9 pr-4 py-2 border border-[#EDE8E3] rounded-full text-sm bg-white outline-none w-[200px] focus:ring-1 focus:ring-[#0F766E]" />
          </div>
        </div>

        {/* Big Feature */}
        <div className="relative rounded-[20px] overflow-hidden shadow-sm hover:shadow-md cursor-pointer group mb-6 h-[260px] md:h-[340px]">
          <img
            src={FEATURED.image}
            alt={FEATURED.title}
            className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
          <div className="absolute bottom-0 left-0 p-6 md:p-8 text-white">
            <h3 className="text-2xl md:text-3xl font-bold mb-2">{FEATURED.title}</h3>
            <div className="flex items-center text-sm text-gray-200">
              <MapPin size={18} className="mr-2" />
              {FEATURED.location}
            </div>
          </div>
        </div>

        {/* Small Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {OTHERS.map((plan, idx) => (
            <div key={idx} className="relative h-[220px] rounded-[16px] overflow-hidden shadow-sm hover:shadow-md cursor-pointer group">
              <img
                src={plan.image}
                alt={plan.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
              <div className="absolute bottom-0 left-0 p-4 text-white">
                <h3 className="text-[17px] font-semibold leading-tight mb-2">{plan.title}</h3>
                <div className="flex items-center text-xs text-gray-200">
                  <MapPin size={14} className="mr-1" />
                  {plan.location}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
